// extracted by mini-css-extract-plugin
module.exports = {"pagMesInfo":"codiespectador_pagMesInfo__k58Ad","clickable":"codiespectador_clickable__U2Lz5"};